import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { SortType } from "@swimlane/ngx-datatable";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { BoletaHonorariosEmitida } from "src/app/models/BoletaHonorarios/BoletaHonorariosEmitida";
import { BheService } from "src/app/services/bhe.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import Swal, { SweetAlertIcon } from "sweetalert2";
import * as FileSaver from "file-saver";
import { PermissionService } from "src/app/services/permission.service";
import { ConfigMantenedorBhe } from "./config-mantenedor-bhe";
import { BheFilter } from "src/app/models/BoletaHonorarios/BheFilter";
import { NgbActiveModal, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { BHEemitidaFilter } from "src/app/models/BoletaHonorarios/BHEemitidaFilter";
import { ThrowStmt } from "@angular/compiler";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { BoletaHonorarioRequest } from "src/app/models/BoletaHonorarios/BoletaHonorariosRequest";
import { ClausulaVentas } from "src/app/models/Dte/Exportacion/ClausulaVentas";
import { FormBuilder, FormGroup,NgForm, Validators } from "@angular/forms";
import * as _moment from "moment";
import { Moment } from "moment";
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from "ng-pick-datetime";
import { MomentDateTimeAdapter } from "ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class";
import { ConciliacionRequestBHE } from "src/app/models/BoletaHonorarios/ConciliacionRequestBHE";
import { EmailBH } from "src/app/models/BoletaHonorarios/EmailBH";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { EmisorService } from "src/app/services/emisor.service";
import { Papa, ParseResult } from "ngx-papaparse";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { SolicitudFacturacionMasiva } from "src/app/models/SolicitudFacturacionMasiva";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';


const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
	parseInput: "MM/YYYY",
	fullPickerInput: "l LT",
	datePickerInput: "MM/YYYY",
	timePickerInput: "LT",
	monthYearLabel: "MMM YYYY",
	dateA11yLabel: "LL",
	monthYearA11yLabel: "MMMM YYYY",
};
@Component({
	selector: "app-mantenedor-bhe-emitidos",
	templateUrl: "./mantenedor-bhe-emitidos.component.html",
	styleUrls: ["./mantenedor-bhe-emitidos.component.scss"],
	providers: [
		NgbActiveModal,
		{
			provide: DateTimeAdapter,
			useClass: MomentDateTimeAdapter,
			deps: [OWL_DATE_TIME_LOCALE],
		},
		{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
		{ provide: OWL_DATE_TIME_LOCALE, useValue: "es" },
	],
})
export class MantenedorBheEmitidosComponent implements OnInit {
	@ViewChild("confirmSwal") private confirmSwal: SwalComponent;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	public sucursalId: string;
	public filterDescription: string;
	loading: boolean = false;
	public componentStarted: boolean = false;
	public rowsMantenedor: BoletaHonorariosEmitida[] = [];
	public configScroll: PerfectScrollbarConfigInterface = {};
	public selected: BoletaHonorariosEmitida[] = []; //BHE seleccionadas por checkbox
	public page: Page = new Page();
	public filter: BHEemitidaFilter = new BHEemitidaFilter();
	SortType = SortType;
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public configLocal = ConfigMantenedorBhe;
	public currentModalRef: NgbModalRef;
	public selectedBhe: BoletaHonorariosEmitida;
	public todayString = moment();
	private currentEmisorId = this.tokenService.getCompany();
	private currentUsuarioId = this.tokenService.getUser().id;
	public cantidadBHE: number;
	public maxBHE: number;
	public empresasSource: Emisor[];
	public isSuperAdmin: boolean = this.tokenService.getUser().superAdmin;
	public files: File[] = [];
	public wrongDelimiter: boolean = false;
	public validDate: boolean = true;
	public validFile: boolean = false;
	public invalidColumns: Array<string> = [];
	public fileData: Object[];
	public sumaResumenDocumento: [number, number];
	public sumOfDocumentDetails: number;
	public resultedFileDataDocuments: any[];
	public numberOfDocumentosToSend: number;
	public totalFinal: number;
	public externalValidFile: boolean = false;
	public validationMessage: string = "";
	public conciliacionDate: any = moment();
	public currentUser = this.tokenStorage.getUser() as SessionUser;
	fileIdState: Observable<object>;
	fileIdValue: string;
	public dateConciliacion: any = { startDate: null, endDate: null };
	private modalImportedBheSii: NgbModalRef;
	locale = {
			daysOfWeek: moment.weekdaysMin(),
			monthNames: moment.monthsShort(),
			firstDay: moment.localeData().firstDayOfWeek(),
			applyLabel: "ok",
			clearLabel: "Limpiar",
			format: "MM/YYYY",
		};

	constructor(public utilities: UtilitiesService, private formBuilder: FormBuilder, 
		private papaParser: Papa, private tokenStorage: TokenStorageService,
		public activatedRoute: ActivatedRoute,
		private bheService: BheService, private ref: ChangeDetectorRef, public permissions: PermissionService, private localStorage: LocalStorageService, private modalService: NgbModal, private router: Router, private emisorService: EmisorService, private planUsuarioService: PlanUsuarioService, private tokenService: TokenStorageService, private sessionUserService: SessionUserService) {
		this.filter.emisorID = this.currentEmisorId;

		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		if (this.isSuperAdmin) {
			this.getEmisoresFullList();
		}
		this.checkStateId();
		if (this.fileIdState) {
			this.getFileIdInState();
		}
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.activatedRoute.paramMap.subscribe(() => {});
		let sessionEmisor = this.empresasSource.find((emisor) => emisor.emisorId == this.currentEmisorId);

		this.planUsuarioService.getCurrentDocuments(sessionEmisor.planUsuarioId).subscribe((resp) => {
			this.maxBHE = resp.maxbhes;
			this.cantidadBHE = resp.bhes;
			this.ref.detectChanges();
		});
		this.setPage({ offset: 0 });
	}

	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		this.bheService.getDataByPageEmitido(this.filter, localPage).subscribe(
			(result) => {
				this.loading = false;
				this.rowsMantenedor = result.data as BoletaHonorariosEmitida[];
				this.ref.detectChanges();
				this.setPagefromResponse(this.page, result);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en lista",
					text: "No fue posible obtener la lista de boletas de honorarios emitidas. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
	}
	
	setSwalAndFire(swalReference: SwalComponent, iconString: SweetAlertIcon, titleString: string, textString: string) {
		swalReference.icon = iconString;
		swalReference.title = titleString;
		swalReference.text = textString;
		swalReference.fire();
	}
	
	openAnularBheModal(modalRef, row: BoletaHonorariosEmitida) {
		this.selectedBhe = row;
		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	closeAnularBheModal() {
		this.currentModalRef.close();
	}

	anularBhe(event: BoletaHonorarioRequest) {
		this.loading = true;
		this.bheService.nullifyBHE(event).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Anulación exitosa",
					text: "Se ha anulado correctamente la boleta de honorarios Folio: " + event.BH.folio + " del Receptor: " + event.BH.nombreReceptor,
				});
				this.setPage({ offset: 0 });
				this.currentModalRef.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en anulación",
					text: "No fue posile anular la boleta de honorarios Folio: " + event.BH.folio + " del Receptor: " + event.BH.nombreReceptor + ". Detalles:" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	navigateToBheEmisor() {
		this.router.navigateByUrl("emisor-boletas-honorarios");
	}
	downloadPDF(boleta: BoletaHonorariosEmitida) {
		this.loading = true;
		this.bheService.getPdf(boleta).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, boleta);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al descargar pdf",
					text: "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	openDatePickerImportedBhe(modalRef, month: boolean) {
			if (month) this.locale.format = "MM/YYYY";
			else this.locale.format = "DD/MM/YYYY";
			//this.dateConciliacion = null;
			this.dateConciliacion.startDate = moment().startOf("day");
			this.dateConciliacion.endDate = moment().subtract(1, "days").startOf("day");
			this.modalImportedBheSii = this.modalService.open(modalRef, {
				windowClass: "",
				size: "md",
				centered: true,
			});
		}

	importBheSii(conciliacionRequest: NgForm) {
		if (conciliacionRequest.valid && this.validDate) {
			Swal.fire({
			title: "¿Desea importar bhes desde SII?",
			text: "Se buscará y conciliará en el S.I.I los registros de las BHE que hayan sido emitidas.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Si, importar",
			cancelButtonText: "Cancelar",
			}).then((result) => {
			if (result.isConfirmed) {
				this.loading = true;
				let conciliacion = new ConciliacionRequestBHE();
				conciliacion.emisorId = this.currentEmisorId;
				conciliacion.usuarioId = this.currentUsuarioId;
				if (this.locale.format === "MM/YYYY") {
				const fechaMensual = moment(this.dateConciliacion.startDate, "MM/YYYY").startOf("month");
				conciliacion.fecha = fechaMensual.format("DD/MM/YYYY");
				} else {
				conciliacion.fecha = moment(this.dateConciliacion.startDate).format("DD/MM/YYYY");
				}
				this.bheService.getEmitedDataSiiEmitidas(conciliacion).subscribe(
				(res) => {
					this.loading = false;
					this.ref.detectChanges();
					this.currentSwal.icon = "success";
					this.currentSwal.title = "Importación Exitosa de Bhes desde Sii";
					this.currentSwal.text = "Se importaron correctamente los Bhes desde Sii";
					this.currentSwal.fire();
					this.modalImportedBheSii.close();
					this.setPage({ offset: 0 });
				},
				(err) => {
					this.loading = false;
					this.ref.detectChanges();
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error al Importar Bhes desde Sii";
					this.currentSwal.text =
					"No es posible realizar la importación de Bhe desde el sii. Intente mas tarde. " +
					this.utilities.setErrorMessageFromArray(err.error);
					this.currentSwal.fire();
				}
				);
			}
			});
		}
		}
	detectChangeDate(event) {
		this.validDate = true;
		let fromDate: any;
		if (event.startDate != null) {
			this.dateConciliacion = event;
		} else {
			if (event.target != null && event.target.value != null) {
				this.validDate = moment(event.target.value, this.locale.format, true).isValid();
				if (this.validDate) {
					fromDate = new Object();
					fromDate.startDate = moment(event.target.value, this.locale.format);
					this.dateConciliacion = fromDate;
				}
			}
		}
	}

	searchElementsByFilter(event) {
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter.regionReceptor = event.region;
		this.filter.comunaReceptor = event.comuna;
		this.filter[event.criterio] = event.busqueda;
		this.filter.importada = event.importada ?? null;
		this.filter.anulada = event.anulada ?? null;
		this.filter.terceros = event.terceros ?? null;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.setPage({ offset: 0 });
	}
	setPagefromResponse(currentPage: Page, data: PagedResponse<BoletaHonorariosEmitida>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	responseToPdfDownload(responseB64, boleta: BoletaHonorariosEmitida) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, "boleta_honorarios_n_" + boleta.folio.toString() + "_" + boleta.nombreReceptor + ".pdf");
		this.loading = false;
		this.ref.detectChanges();
	}
	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}
	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((dte) => {
					this.selected = this.selected.filter((selectedDte) => selectedDte.boletaHonorarioId !== dte.boletaHonorarioId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((dte) => {
				this.selected = this.selected.filter((selectedDte) => selectedDte.boletaHonorarioId !== dte.boletaHonorarioId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	chosenYearHandler(normalizedYear: moment.Moment) {
		let ctrlValue = moment(this.conciliacionDate);
		ctrlValue.year(moment(normalizedYear).year());
		this.conciliacionDate = moment(ctrlValue);
		this.ref.detectChanges();
	}
	chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
		let ctrlValue = moment(this.conciliacionDate);
		ctrlValue.month(moment(normalizedMonth).month());
		this.conciliacionDate = moment(ctrlValue);
		this.ref.detectChanges();
		datepicker.close();
	}
	openConciliacionModal(modalRef) {
		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	openEnvioCorreoModal(modalRef, row) {
		this.selectedBhe = row;
		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	sortByProperty(rowsOfDocumentos: any[], propertyKey: string): any[] {
		var groupBy = function (rowsOfDocumentos, propertyKey) {
			return rowsOfDocumentos.reduce(function (rv, x) {
				(rv[x[propertyKey]] = rv[x[propertyKey]] || []).push(x);
				return rv;
			}, {});
		};
		return groupBy(rowsOfDocumentos, propertyKey);
	}

	sendCorreo(req: EmailBH) {
		req.emisorId = this.currentEmisorId;
		this.loading = true;
		this.bheService.sendEmailBHEmitido(req).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Correo enviado",
					text: "Se envió correctamente el correo con la boleta de honorarios seleccionada",
				});
				this.currentModalRef.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al enviar correo",
					text: "No fue posible enviar correo con la boleta de honorarios seleccionada",
				});
			}
		);
	}

	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.empresasSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	getFileIdInState() {
		this.loading = true;
		this.fileIdState
			.subscribe((result) => {
				this.fileIdValue = result["paramId"];
				if (this.fileIdValue) {
					this.filter.importacionMasivaId = this.fileIdValue ? this.fileIdValue : "";
				}				
				this.filterDescription = result["filterDescription"];
				this.loading = false;
			})
			.add(() => {
				this.loading = false;
			});
	}

  checkStateId() {
		this.fileIdState = this.activatedRoute.paramMap.pipe(
			map(() => {
				return window.history.state;
			})
		);
	}
}
